export default function PrivacyPolicy() {
  return (
    <main style={{ padding: "40px", maxWidth: "1000px", margin: "auto" }}>
      <h1>Privacy Policy</h1>

      <iframe
        src="https://merchant.razorpay.com/policy/S2KjQ8ckWXnkCw/privacy"
        title="Privacy Policy"
        width="100%"
        height="1200"
        style={{ border: "none" }}
      />
    </main>
  );
}